import { styled } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";

export const ContentBox = styled(Box)(({ theme }) => ({
    maxWidth: 1200,
    width: "100%",
    padding: theme.spacing(4, 4),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  }));
  
  export const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    fontWeight: 600,
  }));
  
  export const TitleText = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  }));
  
  export const SubtitleText = styled(Typography)(({ theme }) => ({
    fontWeight: 500,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  }));


export const PageContainer = styled(Box)(({ theme }) => ({
    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
    padding: theme.spacing(8, 2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }));
  
  